import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable  @typescript-eslint/no-explicit-any */
import { path } from 'ramda';
import { getMultiSuggest } from '../../utils/getMultiSuggest';
import { requestAction, successAction, failureAction } from './requestActions';
import { FLATS_NOT_FOUND_ERROR, SERVER_ERROR } from '../../constants/geosuggestErrorMessages';

var processResponse = function processResponse(res) {
  var suggestLength = path(['suggestions', 'addresses', 'length'], res);

  if (suggestLength) {
    return successAction(res);
  }

  return failureAction(FLATS_NOT_FOUND_ERROR);
};
/**
 * Экшн загружает данные саджеста адресов из яндексовской апихи
 * */


export var getFlatGeoSuggest = function getFlatGeoSuggest(addressChunk, targetPage) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var config, logger, apiKey, suggestResult, action;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              config = context.config, logger = context.logger;
              dispatch(requestAction());
              apiKey = config.get('valuation.YandexApiKey');

              if (!apiKey) {
                _context.next = 17;
                break;
              }

              _context.prev = 4;
              _context.next = 7;
              return getMultiSuggest({
                yandex: {
                  value: addressChunk.trim(),
                  apiKey: apiKey
                },
                targetPage: targetPage
              });

            case 7:
              suggestResult = _context.sent;
              action = processResponse(suggestResult);
              dispatch(action);
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              dispatch(failureAction(SERVER_ERROR));

            case 15:
              _context.next = 19;
              break;

            case 17:
              logger.error('Failed get valuation.YandexApiKey. Suggest not working.', {
                domain: 'frontend-valuation-main-filters-widget__getFlatGeoSuggest'
              });
              dispatch(failureAction(SERVER_ERROR));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 12]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};